// extracted by mini-css-extract-plugin
module.exports = {"location":"network_location_32fN-VC","popupNameTrigger":"network_popupNameTrigger_3am46xg","popupNameContent":"network_popupNameContent_2G2kdpM"};